document.addEventListener('DOMContentLoaded', () => {
    //
    //// TOGGLE VARIANT PICKER
    //
    const TOGGLE_SEL  = '.js-pair-with-toggle';
    const PICKER_SEL  = '.pair-with--variant-picker';
  
    let openPicker = null;   // currently open picker element
    let openButton = null;   // its controlling button
  
    /* ---------- helpers ---------- */
    const showPicker = (picker, button) => {
      picker.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
      openPicker = picker;
      openButton = button;
      document.addEventListener('click', handleDocClick);
      document.addEventListener('keyup', handleKeyUp);
    };
  
    const hidePicker = () => {
      if (!openPicker) return;
      openPicker.setAttribute('aria-hidden', 'true');
      openPicker.classList.remove('is-visible');
      openButton.setAttribute('aria-expanded', 'false');
      openPicker = openButton = null;
      document.removeEventListener('click', handleDocClick);
      document.removeEventListener('keyup', handleKeyUp);
    };
  
    /* ---------- global listeners ---------- */
    const handleDocClick = (e) => {
      // ignore clicks on the open button or inside the picker
      if (
        e.target.closest(TOGGLE_SEL) === openButton ||
        e.target.closest(PICKER_SEL) === openPicker
      ) return;
      hidePicker();
    };
  
    const handleKeyUp = (e) => {
      if (e.key === 'Escape') hidePicker();
    };
  
    /* ---------- bind each toggle button ---------- */
    document.querySelectorAll(TOGGLE_SEL).forEach(button => {
      const pickerId = button.getAttribute('aria-controls');
      const picker   = document.getElementById(pickerId);
  
      if (!picker) return; // safety
  
      button.addEventListener('click', () => {
        // If this picker is already open, close it; otherwise open it
        picker === openPicker ? hidePicker() : (hidePicker(), showPicker(picker, button));
      });
    });

    //
    //// ADD TO CART
    //
    document.querySelectorAll('.pair-with--form').forEach(form => {
        form.addEventListener('submit', e => {
        e.preventDefault();

        const submitButton = form.querySelector('button');
        const variantId = form.querySelector('input[name="id"]')?.value;
        const overlay = form.closest('.pair-with--item')?.querySelector('.pair-with--loading-overlay');
        if (!variantId) return;

        submitButton.disabled = true;
        overlay?.setAttribute('aria-hidden', 'false');

        addItemToCart(variantId)
            .then(() => {
            // close the variant drawer
            const picker = form.closest('.pair-with--variant-picker');
            if (picker) {
                picker.classList.remove('is-visible');
                picker.setAttribute('aria-hidden', 'true');
                document.querySelector(`[aria-controls="${picker.id}"]`)
                ?.setAttribute('aria-expanded', 'false');
            }
            })
            .finally(() => {
                submitButton.disabled = false;
                overlay?.setAttribute('aria-hidden', 'true');
            });
        });
    });

    // Using legacy `renderContents` function
    function addItemToCart(variantId, quantity = 1) {
        const payload = {
        items: [{ id: parseInt(variantId), quantity }],
        sections: [
            'cart-drawer-items',
            'cart-icon-bubble',
            'dynamic-cart-footer',
            'dynamic-cart-recommendations'
        ]
        };

        return fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(payload)
        })
        .then(res => res.json())
        .then(data => {
            const drawer = document.querySelector('cart-drawer');
            if (data.sections && drawer?.renderContents) {
                drawer.renderContents(data);
            }
        })
        .catch(err => {
        console.error('Cart add failed:', err);
        alert('There was a problem adding to cart. Please try again.');
        });
    }
});